const Room  = () =>{
    return (
        <p>Room</p>
    )
} 

export default Room;